// extracted by mini-css-extract-plugin
module.exports = {"voucherForm":"_1JYO0Xxe3Sc-TjYJAhtScI","voucherForm__promotionNote":"_1XQfFF3S58zGL1muHoPn5M"};